@if (totalResourceUsages() > 0) {
  <flx-resource-usages-view-references
    [total]="totalResourceUsages()"
    [view]="ResourceUsageView.RESOURCE_USAGES"
    (viewReferences)="viewUsagesClicked.emit(resourceUsages())"
  />
}
